import { Component, Inject, Input, PLATFORM_ID, ViewChild, TemplateRef } from '@angular/core';
import { Product } from '@interfaces/product';
import { UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { CartService } from '@services/cart.service';
import { WishlistService } from '@services/wishlist.service';
import { CompareService } from '@services/compare.service';
import { RootService } from '@services/root.service';
import { AuthenticationService } from '@app/_services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AskVendorComponent } from '@app/shared/components/ask-vendor/ask-vendor.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { SharedService } from '@app/_services/shared.service';
import { CurrencyFormatPipe } from '../../../shared/pipes/currency-format.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { EventCollectorDirective } from '../../../_directives/events-collector/events.collector';
import { RouterLink } from '@angular/router';
import { FlexModule } from '@angular/flex-layout/flex';
import { ProductOptionsComponent } from '../../page-product/product-options/product-options.component';
import { ProductGalleryComponent } from '../../../shared/components/product-gallery/product-gallery.component';
import { NgIf, NgFor } from '@angular/common';

export type ProductLayout = 'standard' | 'sidebar' | 'columnar' | 'quickview';

@Component({
    selector: 'app-service',
    templateUrl: './service.component.html',
    styleUrls: ['./service.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, ProductGalleryComponent, ProductOptionsComponent, FlexModule, RouterLink, EventCollectorDirective, NgFor, MatExpansionModule, MatIconModule, TranslateModule, CurrencyFormatPipe]
})
export class ServiceComponent {
    userDetails: any;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private cart: CartService,
        private wishlist: WishlistService,
        private compare: CompareService,
        public root: RootService,
        private fb: UntypedFormBuilder,
        private authService:AuthenticationService,
        private toastr:ToastrService,
         public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private modalService: BsModalService,
        private shareService: SharedService
    ) {  this.sector = this.shareService.page;}
    sector;
    @Input() layout: ProductLayout;

    @Input() product: any;

    @Input() form;

    addingToCart = false;

    bsModalRef: BsModalRef;
    @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;

    ngOnInit(): void {
        this.userDetails = this.authService.currentUser;

    }

    get amount() {
        return this.form.get('amount') as UntypedFormControl;
      }


    askVendor() {
        const initialState = {
            companyId: this.product.companyId,
            product: this.product,
        };
        this.bsModalRef = this.modalService.show(AskVendorComponent, {
            initialState,
        });
        this.bsModalRef.content.closeBtnName = 'Close';
    }
}
